<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $tc('messages.practice_races', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:flex justify-between">
            <div class="flex flex-wrap gap-2">
                <AppButton v-for="group in meta.links.groups" :key="group.id" :href="group.url" size="sm">
                    {{ group.name }}
                </AppButton>
            </div>

            <div>
                <AppButton v-if="meta.links.edit" :href="meta.links.edit">
                    {{ $t('messages.edit') }}
                </AppButton>
                <AppButton v-else :href="meta.links.create" desired-action>
                    {{ $t('messages.create') }}
                </AppButton>
            </div>
        </div>

        <div class="mt-5">
            <PracticeRace :practice-race="practiceRace" :factions="factions" />
        </div>

        <div class="mt-5 flex flex-wrap gap-2">
            <BadgePill v-for="tag in meta.info.tags" :key="tag.id">
                {{ tag.name }}
            </BadgePill>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.name') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.description') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(race, index) in previousRaces.data"
                                :key="race.id"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ race.name ?? '-' }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ race.description ?? '-' }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                >
                                    <InertiaSquareLinkButton action="show" :href="race.links.show" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="previousRaces" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import PracticeRace from '@/Pages/Teacher/Gamification/Groups/PracticeRace/partials/PracticeRace.vue';
import BadgePill from '@/components/BadgePill.vue';
import AppButton from '@/components/AppButton.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';

export default {
    components: {
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
        InertiaPagination,
        AppButton,
        BadgePill,
        PracticeRace,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'practiceRace', 'previousRaces', 'factions'],
};
</script>
